module.exports = __webpack_public_path__ + "static/spectrum_loop-249d0e99e456dc4afc8ece809aad2340.png";